const dynamicQty = {
    init() {
        this.setupMainQuantityField();
        this.setupAdditionalQuantityInputs();
        this.updateMainPrice();
    },

    getMainProductPrice(): number {
        const mainProduct = document.querySelector<HTMLElement>('.main-product');
        if (mainProduct && mainProduct.dataset.price) {
            return parseFloat(mainProduct.dataset.price);
        }
        return 0;
    },

    getMainQuantity(): number {
        const mainQuantityField = document.querySelector<HTMLInputElement>('.main-quantity');
        if (mainQuantityField) {
            return parseInt(mainQuantityField.value) || 1;
        }
        return 1;
    },

    calculateAdditionalPrice(): number {
        let additionalPrice = 0;
        const additionalProducts = document.querySelectorAll<HTMLElement>('.additional-products');

        additionalProducts.forEach(product => {
            const quantityInput = product.querySelector<HTMLInputElement>('.component-config-input');
            if (quantityInput) {
                const quantity = parseInt(quantityInput.value) || 0;
                const price = parseFloat(product.dataset.price || "0");
                additionalPrice += price * quantity; 
            }
        });

        return additionalPrice;
    },

    formatCurrency(value: number): string {
        return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    updateMainPrice(): void {
        const basePrice = this.getMainProductPrice();
        const mainQuantity = this.getMainQuantity();
        const additionalPrice = this.calculateAdditionalPrice();
        
        const totalPrice = (basePrice + additionalPrice) * mainQuantity;
        // const totalPrice = (basePrice * mainQuantity) + additionalPrice; 
        const mainPriceElement = document.getElementById('main-price') as HTMLElement;
        
        if (mainPriceElement) {
            mainPriceElement.textContent = `$${this.formatCurrency(totalPrice)}`;
            mainPriceElement.classList.add('product-header__price');
        }
    },

    setupMainQuantityField(): void {
        const mainQuantityField = document.querySelector<HTMLInputElement>('.main-quantity');
        const hiddenInputs = document.querySelectorAll<HTMLInputElement>('.jsHiddenQty');
        
        if (mainQuantityField) {
            mainQuantityField.addEventListener('focus', () => {
                if (mainQuantityField.value === '1') {
                    mainQuantityField.value = ''; 
                    
                }
            });

            mainQuantityField.addEventListener('input', () => this.updateMainPrice());

            mainQuantityField.addEventListener('input' , () => {
                hiddenInputs.forEach(input => {
                    input.value =  mainQuantityField.value;
                    if (mainQuantityField.value === '') {
                        input.value = '1';
                    } else {
                        input.value =  mainQuantityField.value;
                    }
                    console.log(input.value);
                })
            });

            mainQuantityField.addEventListener('blur', () => {
                if (mainQuantityField.value === '') {
                    mainQuantityField.value = '1';
                    this.updateMainPrice();
                }
            });
        }
    },

    setupAdditionalQuantityInputs(): void {
        const additionalQuantityInputs = document.querySelectorAll<HTMLInputElement>('.additional-products .component-config-input');
        additionalQuantityInputs.forEach(input => {
            input.addEventListener('change', () => this.updateMainPrice());
        });
    },




};

export default dynamicQty;

document.addEventListener('DOMContentLoaded', () => {
    dynamicQty.init();
});





